export enum MainArea {
  'Dashboard' = 1,
  'CampaignIndex' = 2,
  'CreateCampaign' = 3,
  'NewCampaign' = 4,
  'UpdateNumberBases' = 5,
}
